<nav
  class="bottom-nav-shell fixed bottom-4 left-1/2 -translate-x-1/2 transform-gpu bg-black/33 px-2 py-[5px] w-full max-w-[calc(100%_-_24px)] rounded-[15px] z-999 overflow-hidden backdrop-blur-2xl md:max-w-[1170px] md:w-[90%] md:py-2.5 md:rounded-[30px]">
  <ul class="grid grid-cols-4">
    <li class="md:flex md:items-center md:justify-center">
      <a
        [routerLink]="['/', ERoute.Home]"
        routerLinkActive
        (click)="triggerHaptic()"
        #cases="routerLinkActive"
        [ngClass]="{ 'bg-[#44546c]': cases.isActive }"
        class="flex items-center flex-col justify-center text-center py-2.5 rounded-[12px] transition-colors duration-150 md:max-w-[140px] md:w-full md:rounded-[24px]">
        <div class="w-6 h-6 relative mb-1 flex items-center justify-center md:w-13.5 md:h-13.5 md:mb-2">
          <img src="/icons/case-icon.svg" class="md:w-full md:h-auto" alt="Case icon" />
        </div>
        <span class="text-white text-[13px] leading-[15px] font-medium md:text-xl md:leading-[23px]"> {{ 'nav.cases' | translate }} </span>
      </a>
    </li>

    <li class="md:flex md:items-center md:justify-center">
      <a
        [routerLink]="['/', ERoute.MiniGames]"
        routerLinkActive
        (click)="triggerHaptic()"
        #miniGames="routerLinkActive"
        [ngClass]="{ 'bg-[#44546c]': miniGames.isActive }"
        class="flex items-center flex-col justify-center text-center py-2.5 rounded-[12px] transition-colors duration-150 md:max-w-[140px] md:w-full md:rounded-[24px]">
        <div class="w-6 h-6 relative mb-1 flex items-center justify-center md:w-13.5 md:h-13.5 md:mb-2">
          <img src="/icons/mini-game-icon.svg" class="md:w-full md:h-auto" alt="Mini games icon" />
        </div>
        <span class="text-white text-[13px] leading-[15px] font-medium md:text-xl md:leading-[23px]"> {{ 'nav.minigames' | translate }} </span>
      </a>
    </li>
    <li class="md:flex md:items-center md:justify-center">
      <a
        [routerLink]="['/', 'leaders']"
        routerLinkActive
        (click)="triggerHaptic()"
        #roulette="routerLinkActive"
        [ngClass]="{ 'bg-[#44546c]': roulette.isActive }"
        class="flex items-center flex-col justify-center text-center py-2.5 rounded-[12px] transition-colors duration-150 md:max-w-[140px] md:w-full md:rounded-[24px]">
        <div class="w-6 h-6 relative mb-1 flex items-center justify-center md:w-13.5 md:h-13.5 md:mb-2">
          <img src="/icons/leaders.svg" class="md:w-full md:h-auto" alt="Roulette icon" />
        </div>
        <span class="text-white text-[13px] leading-[15px] font-medium md:text-xl md:leading-[23px]"> Рейтинг </span>
      </a>
    </li>
    <li class="md:flex md:items-center md:justify-center">
      <a
        [routerLink]="['/', ERoute.Profile]"
        routerLinkActive
        (click)="triggerHaptic()"
        #profile="routerLinkActive"
        [ngClass]="{ 'bg-[#44546c]': profile.isActive }"
        class="flex items-center flex-col justify-center text-center py-2.5 rounded-[12px] transition-colors duration-150 md:max-w-[140px] md:w-full md:rounded-[24px]">
        <div class="w-6 h-6 relative mb-1 flex items-center justify-center md:w-13.5 md:h-13.5 md:mb-2">
          <img src="/icons/profile-icon.svg" class="md:w-full md:h-auto" alt="Profile icon" />
        </div>
        <span class="text-white text-[13px] leading-[15px] font-medium md:text-xl md:leading-[23px]"> {{ 'nav.profile' | translate }} </span>
      </a>
    </li>
  </ul>
</nav>
